import { render } from "./zoom-in.svg?vue&type=template&id=638a62ae?inline"
const script = {}
script.render = render

export default script